//
// LineAttributes.js
// gtl
//
// Generated by Robots v0.
// Copyright (c) SAS Institute Inc. All rights reserved.
//
// DO NOT EDIT THIS FILE. IT IS GENERATED BY ROBOTS.
//
// Disable camelcase rule for generated code.
/* eslint-disable camelcase */
import { createModule } from "@sas-dvr/ltjs-commons/moduleBuilder";
import EventDispatcher from "@sas-dvr/ltjs-commons/events/EventDispatcher";
import "../../../lib";
import "./AttributesModel";
import "@sas-dvr/ltjs-commons/util/Dimension";
import "@sas-dvr/ltjs-commons/styles/LineInterpolation";
import "@sas-dvr/ltjs-commons/models/attributes/LineAttributesInterface";

var LineAttributes = createModule("gtl::LineAttributes", ["commons::PropertyOwner","commons::BaseModel","gtl::GTLModel","gtl::AttributesModel"], EventDispatcher, [
    ,
    {
        lineStyle: 3,
        lineThickness: 1,
        transparency: 5,
        lineColor: 10,
        lineInterpolation: 4,
    },
    ,
    ,
    {
        copyFromBundle: [0,1],
        setStyle: [0,1],
        asLineAttributesInterface: [1],
        setStyleElement: [0,4],
        setStyleElementChain: [0,[4]],
        copyFrom: [0,1],
    },
    {
        _create: [4],
    },
    ,
]);
export default LineAttributes;
